import { render, staticRenderFns } from "./ReconciliacaoPayPal.vue?vue&type=template&id=6fc60b99&"
import script from "./ReconciliacaoPayPal.vue?vue&type=script&lang=js&"
export * from "./ReconciliacaoPayPal.vue?vue&type=script&lang=js&"
import style0 from "./ReconciliacaoPayPal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports